<script setup lang="ts">
const route = useRoute()
const slug = route.params.slug as string

const { data: post } = await useFetch(`/api/blog/${slug}`)

if (!post.value) {
  throw createError({ statusCode: 404, statusMessage: 'Post not found' })
}

useSeoMeta({
  title: `${(post.value as any).title} — Shakir Abdulrahim`,
  ogTitle: `${(post.value as any).title} — Shakir Abdulrahim`,
  description: (post.value as any).excerpt,
})

function formatDate(date: string) {
  return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
}
</script>

<template>
  <div class="py-24">
    <article class="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
      <!-- Back -->
      <NuxtLink to="/blog" class="mb-8 inline-flex items-center gap-1 text-sm text-[var(--color-text-muted)] transition-colors hover:text-[var(--color-amber)]">
        <UIcon name="i-lucide-arrow-left" class="size-4" />
        Back to blog
      </NuxtLink>

      <!-- Meta -->
      <div class="mb-4 flex items-center gap-3 text-sm text-[var(--color-text-muted)]">
        <time v-if="(post as any).date_published">{{ formatDate((post as any).date_published) }}</time>
        <span v-if="(post as any).read_time" class="flex items-center gap-1">
          <UIcon name="i-lucide-clock" class="size-3.5" />
          {{ (post as any).read_time }} min read
        </span>
      </div>

      <h1 class="mb-6 text-4xl font-bold text-[var(--color-text)] sm:text-5xl">
        {{ (post as any).title }}
      </h1>

      <!-- Tags -->
      <div v-if="(post as any).tags" class="mb-10 flex flex-wrap gap-2">
        <span
          v-for="tag in (post as any).tags"
          :key="tag"
          class="rounded-md border border-[var(--color-card-border)] bg-[var(--color-surface-hover)] px-3 py-1 text-sm text-[var(--color-text-muted)]"
        >
          {{ tag }}
        </span>
      </div>

      <!-- Content -->
      <div
        v-if="(post as any).content"
        class="prose prose-invert max-w-none text-[var(--color-text-muted)] prose-headings:text-[var(--color-text)] prose-a:text-[var(--color-amber)] prose-strong:text-[var(--color-text)] prose-code:text-[var(--color-amber)] prose-pre:bg-[var(--color-surface)] prose-pre:border prose-pre:border-[var(--color-card-border)]"
        v-html="(post as any).content"
      />
    </article>
  </div>
</template>
